import * as React from "react";

import { UitkHeading, UitkText } from "uitk-react-text";

import { WizardRegionHotwireHeadingProps } from "components/flexComponents/WizardPWARegions/WizardRegionHotwire/typings";

export const DesktopHeading = ({ title, innerTitle }: WizardRegionHotwireHeadingProps) => (
  <UitkHeading tag="h1" size={3}>
    {title && <UitkText weight="regular">{title}</UitkText>}
    {innerTitle && (
      <UitkText size={900} weight="bold">
        {innerTitle}
      </UitkText>
    )}
  </UitkHeading>
);
